import { FC } from 'react';
import { FormControl } from 'react-bootstrap';
import { EasyField } from 'react-bootstrap-formutil';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import { RegexTypeEnum, useCheckLatin } from 'hooks/useCheckRegex';
import { CustomerInfoKeyType } from 'types/customer';
import { printf } from 'utils/i18n';

export const getFieldsOfTaxNumber = (maskTaxIdentificationNumber: string | undefined): CustomerInfoKeyType[] => {
    const baseFields: CustomerInfoKeyType[] = ['tax_identification_number'];

    return baseFields.concat(maskTaxIdentificationNumber ? ['mask_tax_identification_number'] : []);
};

export interface TaxNumberFormutil {
    tax_identification_number: string;
    // 目前仅在受益人信息里使用掩码，后续server侧将下掉明文字段，web + app的开户流程也需要使用掩码
    mask_tax_identification_number?: string;
}

interface TaxNumberProps extends FormGroupProps {
    disabled?: boolean;
    maskTaxIdentificationNumber?: string | null;
}

const TaxNumber: FC<TaxNumberProps> = ({
    disabled,
    maskTaxIdentificationNumber,
    checker: customChecker,
    ...restProps
}) => {
    const { trigger: triggerCheckLatin, renderCheckingPrompt } = useCheckLatin(RegexTypeEnum.TIN);

    return (
        <>
            {maskTaxIdentificationNumber && (
                <EasyField
                    name="mask_tax_identification_number"
                    type="hidden"
                    $defaultValue={maskTaxIdentificationNumber}
                />
            )}
            <FormGroup
                label={__('纳税识别号')}
                name="tax_identification_number"
                checker={(value: string, ...restCheckerParams) => {
                    if (disabled) {
                        return true;
                    }

                    if (!value) {
                        return __('请填写纳税识别号');
                    }

                    // 税号当前值与掩码相同时, 不做校验
                    if (maskTaxIdentificationNumber && maskTaxIdentificationNumber === value) {
                        return true;
                    }

                    if (customChecker) {
                        const result = customChecker(value, ...restCheckerParams);

                        // 不能result返回了true就提前结束判断, 因为还有后续判断
                        if (result !== true) {
                            return result;
                        }
                    }

                    if (value.length > 50) {
                        return printf(__('纳税识别号中填写的内容过长，不超过%s个字符'), 50);
                    }

                    return triggerCheckLatin(value);
                }}
                {...restProps}>
                <FormControl disabled={disabled} placeholder={__('纳税识别号')} />
            </FormGroup>
            {renderCheckingPrompt()}
        </>
    );
};

export default TaxNumber;
